import React, { useCallback, useEffect, useRef } from 'react';
import { useFocusedField } from '../../../../contexts/focused-field-provider';
import { useScroll } from '../../../../contexts/scroll-provider';
export const Focusable = _ref => {
  let {
    children,
    fieldId
  } = _ref;
  const viewRef = useRef(null);
  const {
    scrollTo
  } = useScroll();
  const {
    focusedFieldId,
    setFocusedFieldId
  } = useFocusedField();
  const focusInput = useCallback(() => {
    var _viewRef$current;
    const input = (_viewRef$current = viewRef.current) == null ? void 0 : _viewRef$current.querySelector('input');
    if (input) {
      input.focus({
        preventScroll: true
      });
    } else {
      var _viewRef$current2;
      const button = (_viewRef$current2 = viewRef.current) == null ? void 0 : _viewRef$current2.querySelector('button');
      button == null || button.focus({
        preventScroll: true
      });
    }
  }, []);
  useEffect(() => {
    if (viewRef.current && fieldId === focusedFieldId) {
      setFocusedFieldId(undefined);
      scrollTo(viewRef.current);
      focusInput();
    }
  }, [scrollTo, fieldId, focusedFieldId, setFocusedFieldId, focusInput]);
  return /*#__PURE__*/React.createElement("div", {
    ref: viewRef
  }, children);
};
//# sourceMappingURL=focusable.js.map